import { LOAD } from '@/config/app'
import Env from '@/config/env'
import ImageService from '@/services/ImageService'

/*
// start the image loading like this.
// specify a load group:
ImageService.load(imageManifest, 'intro')

// get a image
let path = require('@/assets/imgs/1x1.png')
(or) let path = IMAGE_URL.img_1x1

let image = ImageService.get(path)

*/

export let IMAGE_URL = {}

export const getManifest = () => {
  let ext = defaultExt => {
    return ImageService.webp ? 'webp' : defaultExt
  }

  let tg = Env.mobile || Env.tablet ? 'mobile' : 'desktop'
  IMAGE_URL = {
    //crit
    img_1x1: require('@/assets/imgs/1x1.png'),
    loading_bg: require(`@/assets/imgs/loading/bg-${tg}.${ext('jpg')}`),

    //EPOCH_1
    image110: require(`@/assets/imgs/home/epoch-1/image110.${ext('jpg')}`),
    image138: require(`@/assets/imgs/home/epoch-1/image138.${ext('jpg')}`),
    parallax_one: require(`@/assets/imgs/home/epoch-1/parallax-one.${ext('jpg')}`),
    parallax_two: require(`@/assets/imgs/home/epoch-1/parallax-two.${ext('jpg')}`),

    //EPOCH_2,
    image72: require(`@/assets/imgs/home/epoch-2/image72.${ext('jpg')}`),
    image76: require(`@/assets/imgs/home/epoch-2/image76.${ext('jpg')}`),
    image75: require(`@/assets/imgs/home/epoch-2/image75.${ext('jpg')}`),
    image87: require(`@/assets/imgs/home/epoch-2/image87.${ext('jpg')}`),

    //.EPOCH_3,
    e3_img1: require(`@/assets/imgs/home/epoch-3/e3_img1.${ext('jpg')}`),
    e3_img2: require(`@/assets/imgs/home/epoch-3/e3_img2.${ext('jpg')}`),
    e3_img3: require(`@/assets/imgs/home/epoch-3/e3_img3.${ext('jpg')}`),

    //EPOCH_4,
    e4_img1: require(`@/assets/imgs/home/epoch-4/e4_img1.${ext('jpg')}`),
    e4_img2: require(`@/assets/imgs/home/epoch-4/e4_img2.${ext('jpg')}`),
    e4_img3: require(`@/assets/imgs/home/epoch-4/e4_img3.${ext('jpg')}`),
    e4_img4: require(`@/assets/imgs/home/epoch-4/e4_img4.${ext('jpg')}`),
    e4_img5: require(`@/assets/imgs/home/epoch-4/e4_img5.${ext('jpg')}`),

    //CTA
    img_1880: require(`@/assets/imgs/home/cta/1880.${ext('jpg')}`),
    logo_1880: require(`@/assets/imgs/home/cta/logo_1880.${ext('png')}`),
    logo_1880_black: require(`@/assets/imgs/home/cta/logo_1880_black.${ext('png')}`),
  }

  return [
    {
      id: LOAD.GROUPS.CRITICAL,
      urls: [IMAGE_URL.img_1x1, IMAGE_URL.loading_bg],
    },
    {
      id: LOAD.GROUPS.MAIN,
      urls: [IMAGE_URL.img_1880, IMAGE_URL.logo_1880, IMAGE_URL.logo_1880_black],
    },
    {
      id: LOAD.GROUPS.EPOCH_1,
      urls: [IMAGE_URL.image110, IMAGE_URL.image138, IMAGE_URL.parallax_one, IMAGE_URL.parallax_two],
    },
    {
      id: LOAD.GROUPS.EPOCH_2,
      urls: [IMAGE_URL.image72, IMAGE_URL.image76, IMAGE_URL.image75, IMAGE_URL.image87],
    },
    {
      id: LOAD.GROUPS.EPOCH_3,
      urls: [IMAGE_URL.e3_img1, IMAGE_URL.e3_img2, IMAGE_URL.e3_img3],
    },
    {
      id: LOAD.GROUPS.EPOCH_4,
      urls: [IMAGE_URL.e4_img1, IMAGE_URL.e4_img2, IMAGE_URL.e4_img3, IMAGE_URL.e4_img4, IMAGE_URL.e4_img5],
    },
  ]
}
